import React from "react";
import { ControllerRenderProps, FieldError } from "react-hook-form";
import { TextOptions, ValidationConstraints } from "@/components/tasks/types";
import ValidationEditor from "./shared/ValidationEditor";

interface MultiLineTextboxProps {
  name?: string;
  options: TextOptions;
  field: ControllerRenderProps;
  error?: FieldError;
  readOnly?: boolean;
}

export default function MultiLineTextbox({
  name,
  options,
  field,
  error,
  readOnly,
}: MultiLineTextboxProps) {
  const maxChars = options["max-characters"] || 0;

  return (
    <div className="space-y-2">
      <textarea
        {...field}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-vertical ${
          error ? "border-red-500" : "border-gray-300"
        }`}
        rows={4}
        placeholder={`Enter ${name?.toLowerCase()}...`}
        maxLength={maxChars > 0 ? maxChars : undefined}
        readOnly={readOnly}
      />
      {error && <p className="text-sm text-red-600 mt-1">{error.message}</p>}
      {maxChars > 0 && (
        <p className="text-sm text-gray-500">Maximum {maxChars} characters</p>
      )}
    </div>
  );
}

interface MultiLineTextboxEditorProps {
  options: TextOptions;
  validation: ValidationConstraints;
  onOptionsChange: (options: TextOptions) => void;
  onValidationChange: (validation: ValidationConstraints) => void;
}

MultiLineTextbox.Editor = function MultiLineTextboxEditor({
  validation,
  onValidationChange,
}: MultiLineTextboxEditorProps) {
  return (
    <div className="space-y-4">
      <ValidationEditor
        validation={validation}
        promptType="multi-line-textbox"
        onValidationChange={onValidationChange}
      />
    </div>
  );
};
